import React, { useState, useEffect } from "react";
import { Row, Col, Breadcrumb, Card } from 'react-bootstrap';
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import '../../assets/css/brandbook.css';
import { TabView, TabPanel } from 'primereact/tabview';
import Brandbook_data from '../../components/Brandbook_data';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';

const Brandfile = () => {
  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { accessToken, role } = useAuth();
  const allowedRoles = [
    'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
    'Social_Media_Manager', 'Task_manager'
  ];

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${config.apiBASEURL}/BrandBookRoutes/brands-with-overview`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.status === 200 && response.data?.data) {
          setBrands(response.data.data);
        } else {
          setBrands([]); // Ensure brands is always an array
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]); // Handle errors gracefully
      }
      finally {
        setIsLoading(false);
      }
    };

    fetchBrands();
  }, [accessToken]);

  return (
    <>
      <Row className="body_content">
        <Row className="mx-0">
          <Col md={6} lg={6} className="mb-4">
            <Breadcrumb>
              <Breadcrumb.Item active>Brand Book</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {allowedRoles.includes(role) && (
            <Col md={6} lg={6} className="mb-4 text-end">
              <Link to={`/Graphe/dashboard/addbook`}>
                <Button
                  severity="warning"
                  label="Brand Book"
                  icon="pi pi-plus"
                  className="py-2 me-2"
                />
              </Link>
            </Col>
          )}
          <Col md={12} lg={12}>
            <Card>
              <Card.Body className="p-0">
                {isLoading ? (
                  <p className="text-center p-4">Loading brands...</p>
                ) : brands.length === 0 ? (
                  <p className="text-center p-4">No Brand Book Data found.</p>
                ) : (
                  <TabView scrollable>
                    {brands.map((brand) => (
                      <TabPanel key={brand.brand_id} header={brand.brand_name}>
                        <Brandbook_data brandId={brand.brand_id} />
                      </TabPanel>
                    ))}
                  </TabView>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default Brandfile;
